import * as React from 'react'
import { useMemo } from 'react'
import {
  salesTeamsForCurrentUser,
  useGetSalesTeamListOnMount,
} from '@user/store/salesTeam'
import { useAppSelector } from '@user/store/hooks'
import type { IOption, IProviderProps } from '@user/components/Filters'

export function SalesTeamProvider(props: IProviderProps) {
  const { render } = props

  const status = useGetSalesTeamListOnMount({ includeUsers: true })

  const teams = useAppSelector(salesTeamsForCurrentUser)

  const loading = status === 'pending'

  const options = useMemo<IOption[]>(
    () =>
      teams.map<IOption>((t) => ({
        value: t.id,
        label: t.name,
      })),
    [teams],
  )

  return <>{render(options, loading)}</>
}
